import React from 'react';

import Spaced from 'components/Spaced';

const GridItem: React.FCWithChildren = ({ children }) => {
  return <Spaced spacing={3}>{children}</Spaced>;
};

export default GridItem;
